import { Step } from '../flow';
import { useSurvey } from '../SurveyContext';

export function HabitStep({ step }: { step: Step }) {
  const surveyFlow = useSurvey();
  const h = step.habit!;
  const sel = surveyFlow.answers.habits[h.id];
  return (
    <div className="intake-opts">
      {h.options.map((o, i) => (
        <button type="button"
          key={i}
          className="intake-opt"
          aria-pressed={sel === i}
          onClick={() => surveyFlow.setHabit(h.id, i)}
        >
          <span className="intake-k">{i + 1}</span>
          <span>{o.label}</span>
        </button>
      ))}
    </div>
  );
}
